export default __webpack_public_path__ + "7b2534c461eaf20e10189ca71ccb700c.svg";